import * as React from 'react';
import { createComponent } from '@lit/react';
import { BetterTooltipWC } from './better-tooltip.wc';
import {
  GenerateComponentTypeWithChildren,
  GeneratePropsWithRef,
} from '../component-types-generics';

export type BetterTooltipProps =
  GenerateComponentTypeWithChildren<BetterTooltipWC>;

export type BetterTooltipPropsWithRef =
  GeneratePropsWithRef<BetterTooltipProps>;

export const BetterTooltip = createComponent({
  tagName: BetterTooltipWC.tagname,
  elementClass: BetterTooltipWC,
  react: React,
}) as BetterTooltipPropsWithRef;
